export default __webpack_public_path__ + "static/media/pv_composition2.63d46940.jpg";